export const ACCESSORIAL_TEAM = 'OVERRIDE_BILLING_STATUS_REASON_CODE_ACCESSORIAL_TEAM';
export const INCOMPLETE_BOOKING = 'OVERRIDE_BILLING_STATUS_REASON_CODE_INCOMPLETE_BOOKING';
export const MISSING_INVALID_DOCUMENTS = 'OVERRIDE_BILLING_STATUS_REASON_CODE_MISSING_INVALID_DOCUMENTS';
export const MISSING_CUSTOMER_APPROVAL = 'OVERRIDE_BILLING_STATUS_REASON_CODE_MISSING_CUSTOMER_APPROVAL';
export const SYSTEM_ISSUES = 'OVERRIDE_BILLING_STATUS_REASON_CODE_SYSTEM_ISSUES';
export const CUSTOMER_PORTAL = 'OVERRIDE_BILLING_STATUS_REASON_CODE_CUSTOMER_PORTAL';
export const REJECTED_BY_CUSTOMER = 'OVERRIDE_BILLING_STATUS_REASON_CODE_REJECTED_BY_CUSTOMER';
export const AM_INVOICE_RESOLUTION = 'OVERRIDE_BILLING_STATUS_REASON_CODE_AM_INVOICE_RESOLUTION';
export const CUSTOMER_MASTER_RULES = 'OVERRIDE_BILLING_STATUS_REASON_CODE_CUSTOMER_MASTER_RULES';
export const SHIPPER_RATE_CARD = 'OVERRIDE_BILLING_STATUS_REASON_CODE_SHIPPER_RATE_CARD';
export const BILLING_HOLD = 'OVERRIDE_BILLING_STATUS_REASON_CODE_BILLING_HOLD';
export const OTHERS = 'Others';
export const overrideBillingStatusReasonCodes = [
    ACCESSORIAL_TEAM,
    INCOMPLETE_BOOKING,
    MISSING_INVALID_DOCUMENTS,
    MISSING_CUSTOMER_APPROVAL,
    SYSTEM_ISSUES,
    CUSTOMER_PORTAL,
    REJECTED_BY_CUSTOMER,
    AM_INVOICE_RESOLUTION,
    CUSTOMER_MASTER_RULES,
    BILLING_HOLD,
    SHIPPER_RATE_CARD,
    OTHERS,
];
